import PropTypes from 'prop-types';
import { Component } from 'react';
import { goToUrl, replaceUrl } from '../../services/Router';

type Props = {
    to: string;
    push?: boolean;
};

export default class Redirect extends Component<Props> {
    static propTypes = {
        to: PropTypes.string.isRequired,
        push: PropTypes.bool,
    };

    componentDidMount() {
        if (this.props.push) {
            goToUrl(this.props.to);
        } else {
            replaceUrl(this.props.to);
        }
    }

    render() {
        return null;
    }
}
